import { defineStore } from 'pinia';

export const useLocationStore = defineStore('location', {
  state: () => ({
    loaded: false,
    loading: false,
    locations: [] as GoogleLocation[],
  }),
  actions: {
    async load() {
      if (!this.loaded && !this.loading) {
        await this.reload();
      }
    },
    async reload() {
      const { data: auth } = useAuth();
      this.loading = true;
      const { data } = await useApi().get<GoogleLocation[]>(`/organizations/${auth.value!.organization.id}/locations`);
      this.locations = data.value;
      this.loaded = true;
      this.loading = false;
    },
  },
});
